import { useContext } from "react";
import { NotificationCountContext } from "context";

export const useNotificationCount = () => useContext(NotificationCountContext);